/* eslint-disable react/no-unescaped-entities */
export default function MiqExplainer() {
  return (
    <section id="miq" data-testid="miq-section" className="relative py-28 md:py-36 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-14 items-center">
          <div className="lg:col-span-5">
            <div className="text-[11px] uppercase tracking-[0.24em] text-brand-accent font-bold mb-5">
              The Score · MIQ 1.0
            </div>
            <h2 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[1.02]">
              One score that <span className="text-gradient-hero">knows your whole picture</span>.
            </h2>
            <p className="mt-6 text-white/65 text-base sm:text-lg leading-relaxed font-light max-w-xl">
              MIQ is a 0-100 score that learns from every input your body gives — nutrition, training,
              sleep, supplements, peptides, biometrics, mood. Whatever your goal, it tells you exactly
              where you stand and exactly what to change next. It updates the moment you log a meal,
              sync a wearable, or check in.{" "}
              <span className="text-white font-medium">You don't track metrics. You track intelligence.</span>
            </p>

            <div className="mt-9 space-y-4">
              {[
                ["0–40", "Drifting — large gaps in fueling or recovery."],
                ["40–70", "Functional — most signals aligned, room to optimize."],
                ["70–90", "Performing — system is responding to inputs."],
                ["90–100", "Elite — recovery, energy, and adaptation in sync."],
              ].map(([range, desc]) => (
                <div key={range} data-testid={`miq-band-${range}`} className="flex items-baseline gap-5">
                  <div className="font-mono text-sm w-20 shrink-0 text-white/55">{range}</div>
                  <div className="text-sm text-white/80">{desc}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="relative aspect-square max-w-[520px] mx-auto">
              <div className="absolute inset-0 rounded-full conic-ring blur-[1px]" />
              <div className="absolute inset-[10px] rounded-full bg-[#080808] border border-white/10" />
              <div className="absolute inset-[30px] rounded-full border border-white/[0.04]" />
              <div className="absolute inset-[60px] rounded-full border border-white/[0.04]" />
              <div className="absolute inset-0 flex flex-col items-center justify-center text-center">
                <div className="text-[11px] uppercase tracking-[0.28em] text-white/45 font-semibold">MIQ Score</div>
                <div data-testid="miq-big-score" className="font-mono font-bold text-7xl sm:text-8xl mt-2 leading-none">74</div>
                <div className="text-sm text-brand-free font-semibold mt-2">+8 this week</div>
                <div className="mt-6 grid grid-cols-2 gap-x-10 gap-y-3 text-xs text-white/55">
                  <div className="flex items-center gap-2"><span className="h-1.5 w-1.5 rounded-full bg-brand-free" /> Nutrition</div>
                  <div className="flex items-center gap-2"><span className="h-1.5 w-1.5 rounded-full bg-brand-smart" /> Recovery</div>
                  <div className="flex items-center gap-2"><span className="h-1.5 w-1.5 rounded-full bg-brand-genius" /> Training</div>
                  <div className="flex items-center gap-2"><span className="h-1.5 w-1.5 rounded-full bg-brand-accent" /> Biometrics</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
